import "./App.css";
import { Header } from "./components/Header";
import { Content } from "./components/Content";

function App() {
  return (
    <div className="App">
      <Header />
      <hr />
      <Content />
    </div>
  );
}

export default App;
